import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageProviderService {
  setObject(key: string, value: any): void {
    try {
      const jsonString = JSON.stringify(value);
      const encoded = btoa(jsonString);
      localStorage.setItem(key, encoded);
    } catch (err) {
      console.error('Error saving to localStorage', err);
    }
  }

  getObject<T>(key: string): T | null {
    try {
      const encoded = localStorage.getItem(key);
      if (!encoded) return null;

      const jsonString = atob(encoded);
      return JSON.parse(jsonString) as T;
    } catch (err) {
      console.error('Error reading from localStorage', err);
      return null;
    }
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): any {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
